import { getCreditDetail } from '@/lib/fetchUtil';
import { useSession } from 'next-auth/react';
import { useState, useEffect, useRef, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const formatCredits = (credits) => {
  if (credits < 0) return "0";
  if (credits >= 1_000_000) return `${Math.floor(credits / 100_000) / 10}M`; // 1.23M instead of 1.2M
  if (credits >= 1_000) return `${Math.floor(credits / 100) / 10}k`; // 10.9k instead of 11.0k
  return credits.toLocaleString('en-US'); // Add comma separators
};

const CreditsDisplay = () => {
  const [credits, setCredits] = useState(0); // Initialize local state
  const [isOpen, setIsOpen] = useState(false);
  const { data: session } = useSession();
  const ref = useRef(null);

  const toggleInfoCard = () => setIsOpen((prev) => !prev);

  const formattedCredits = useMemo(() => formatCredits(credits), [credits]);

  useEffect(() => {
    if (session?.user) {
      getCreditDetail(session.user).then((res) => {
        console.log(res.balance, "credits");
        setCredits(res.balance); // Update state with API response
      });
    }
  }, [session]);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="relative inline-block" ref={ref}>
      {/* Coin Display */}
      <div
        className="flex flex-col items-center justify-center w-10 h-10 rounded-full bg-[#E6D6FF] text-primary font-bold text-xs cursor-pointer"
        onClick={toggleInfoCard}
        role="button"
        tabIndex={0}
        aria-label="Show credits info"
      >
        <div>{formattedCredits}</div>
        <div className="text-[10px] leading-none">credits</div>
      </div>

      {/* Info Card */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full mt-2 w-auto min-w-[150px] bg-[#854cff] text-white rounded-lg p-4 shadow-lg z-50 lap:right-0 lap:left-auto right-1/2 transform lap:translate-x-0 -translate-x-1/2"
          >
            <div className="flex justify-between items-center">
              <span className="text-2xl font-bold">{credits.toLocaleString('en-US')}</span>
              {/* <button className="border border-white px-3 py-1 text-sm rounded-full hover:bg-white hover:text-[#854cff] transition">
                Add Coins
              </button> */}
            </div>
            <p className="text-xs mt-1">Remaining Credits</p>
            {/* <p className="text-[10px] opacity-80">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </p> */}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreditsDisplay;
